(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-bundle-builder]';
  var DEFAULT_MARKERS = ['2 items · 5%', '3 items · 10%', '4+ items · 15%'];
  var COMPLETE_MARKERS = ['5% ✓', '10% ✓', '15% ✓'];

  function formatMoney(amountInMinorUnits, currencyCode) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currencyCode
    }).format((amountInMinorUnits || 0) / 100);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function getAchievedStepCount(discount) {
    if (discount >= 15) {
      return 3;
    }

    if (discount >= 10) {
      return 2;
    }

    if (discount >= 5) {
      return 1;
    }

    return 0;
  }

  function getSummary(state, cards) {
    var keys = Object.keys(state.items);
    var totalItems = 0;
    var totalPrice = 0;

    keys.forEach(function (key) {
      var qty = state.items[key];
      var card = cards.get(key);

      if (!card || qty <= 0) {
        return;
      }

      totalItems += qty;
      totalPrice += card.price * qty;
    });

    var discount = 0;

    if (totalItems >= 4) {
      discount = 15;
    } else if (totalItems >= 3) {
      discount = 10;
    } else if (totalItems >= 2) {
      discount = 5;
    }

    var discountedTotal = totalPrice - Math.round(totalPrice * (discount / 100));

    return {
      totalItems: totalItems,
      totalPrice: totalPrice,
      discount: discount,
      discountedTotal: discountedTotal
    };
  }

  function updateProgressFill(section, summary) {
    var fill = section.querySelector('[data-progress-fill]');
    var track = section.querySelector('.nom-bundle-builder__progress-track');
    var markers = section.querySelectorAll('[data-progress-marker]');
    var achievedStepCount = getAchievedStepCount(summary.discount);

    if (!fill || !track) {
      return;
    }

    if (achievedStepCount <= 0) {
      fill.style.width = '0%';
      return;
    }

    var activeMarker = markers[achievedStepCount - 1];
    var activeDot = activeMarker && activeMarker.querySelector('.nom-bundle-builder__progress-dot');

    if (!activeDot) {
      fill.style.width = '0%';
      return;
    }

    var trackRect = track.getBoundingClientRect();
    var dotRect = activeDot.getBoundingClientRect();

    if (!trackRect.width) {
      return;
    }

    var dotCenter = (dotRect.left - trackRect.left) + (dotRect.width / 2);
    var fillWidth = clamp((dotCenter / trackRect.width) * 100, 0, 100);

    fill.style.width = fillWidth + '%';
  }

  function getHintMarkup(totalItems) {
    if (totalItems <= 0) {
      return 'Add <span class="nom-bundle-builder__hint-accent">2 items</span> to start saving';
    }

    if (totalItems === 1) {
      return 'Add <span class="nom-bundle-builder__hint-accent">1 more</span> to unlock 5% off';
    }

    if (totalItems === 2) {
      return 'Add <span class="nom-bundle-builder__hint-accent">1 more</span> to unlock 10% off';
    }

    if (totalItems === 3) {
      return 'Add <span class="nom-bundle-builder__hint-accent">1 more</span> to unlock 15% off';
    }

    return '<span class="nom-bundle-builder__hint-accent">15% off</span> unlocked';
  }

  function getStorageKey(section) {
    return [
      'nom-bundle-builder',
      section.dataset.pageHandle || 'preview',
      section.dataset.sectionId
    ].join(':');
  }

  function showStatus(section, message, tone) {
    var status = section.querySelector('[data-bundle-status]');

    if (!status) {
      return;
    }

    if (!message) {
      status.hidden = true;
      status.classList.remove('is-visible');
      status.removeAttribute('data-status-tone');
      status.textContent = '';
      return;
    }

    status.hidden = false;
    status.classList.add('is-visible');
    status.dataset.statusTone = tone || 'info';
    status.textContent = message;
  }

  function normalizeRoot(root) {
    if (!root) {
      return '/';
    }

    return root.slice(-1) === '/' ? root : root + '/';
  }

  function getBundleRedirectPath(root, destination) {
    var path = destination === 'checkout' ? root + 'checkout' : root + 'cart';
    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

    if (!previewThemeId) {
      return path;
    }

    try {
      var url = new URL(path, window.location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return path;
    }
  }

  function shouldUseCartDrawer(destination) {
    return (
      destination !== 'checkout' &&
      window.NomSiteCart &&
      typeof window.NomSiteCart.refresh === 'function'
    );
  }

  function clearLegacyCartDrawerState() {
    if (document.body && document.body.classList) {
      document.body.classList.remove('js-drawer-open-cart', 'js-drawer-open');
    }

    document.querySelectorAll('[data-cart-drawer], .cart-drawer').forEach(function (drawer) {
      drawer.classList.remove('is-open', 'drawer--is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      drawer.style.display = 'none';
    });
  }

  function getShopifyPreviewBarOffset() {
    var previewBar = document.getElementById('PBarNextFrameWrapper');

    if (!previewBar) {
      return 0;
    }

    var rect = previewBar.getBoundingClientRect();
    var style = window.getComputedStyle(previewBar);
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    if (
      rect.height < 1 ||
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      rect.top < viewportHeight - 160
    ) {
      return 0;
    }

    return Math.ceil(rect.height);
  }

  function syncShopifyPreviewBarOffset(section) {
    section.style.setProperty('--nom-shopify-preview-bar-offset', getShopifyPreviewBarOffset() + 'px');
  }

  function refreshNomCartDrawer() {
    if (!window.NomSiteCart || typeof window.NomSiteCart.refresh !== 'function') {
      return Promise.reject(new Error('NOM cart drawer is unavailable.'));
    }

    clearLegacyCartDrawerState();

    return window.NomSiteCart.refresh(true).then(function (cart) {
      clearLegacyCartDrawerState();
      return cart;
    });
  }

  function withTimeout(promise, timeoutMs, message) {
    var timeoutId;
    var timeoutPromise = new Promise(function (_, reject) {
      timeoutId = window.setTimeout(function () {
        reject(new Error(message || 'The cart drawer took too long to update.'));
      }, timeoutMs);
    });

    return Promise.race([promise, timeoutPromise]).finally(function () {
      window.clearTimeout(timeoutId);
    });
  }

  function fetchWithTimeout(url, options, timeoutMs, message) {
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timeoutId;
    var didTimeOut = false;
    var fetchOptions = Object.assign({}, options || {});

    if (controller) {
      fetchOptions.signal = controller.signal;
    }

    var timeoutPromise = new Promise(function (_, reject) {
      timeoutId = window.setTimeout(function () {
        didTimeOut = true;

        if (controller) {
          controller.abort();
        }

        reject(new Error(message || 'The request took too long.'));
      }, timeoutMs);
    });

    var requestPromise = fetch(url, fetchOptions).catch(function (error) {
      if (didTimeOut) {
        throw new Error(message || 'The request took too long.');
      }

      throw error;
    });

    return Promise.race([requestPromise, timeoutPromise]).finally(function () {
      window.clearTimeout(timeoutId);
    });
  }

  function wait(delayMs) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, delayMs);
    });
  }

  function createSubmissionId() {
    return [
      'nom',
      Date.now(),
      Math.random().toString(36).slice(2, 10)
    ].join('-');
  }

  async function fetchCart(root, timeoutMs) {
    var response = await fetchWithTimeout(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }, timeoutMs || 3000, 'The cart took too long to load.');

    if (!response.ok) {
      throw new Error('Unable to load the cart.');
    }

    return response.json();
  }

  function cartHasSubmission(cart, submissionId) {
    return !!(
      submissionId &&
      cart &&
      Array.isArray(cart.items) &&
      cart.items.some(function (line) {
        var properties = line.properties || {};
        return String(properties._nom_bundle_submission_id || '') === submissionId;
      })
    );
  }

  async function findSubmittedBundle(root, submissionId) {
    for (var attempt = 0; attempt < 6; attempt += 1) {
      if (attempt > 0) {
        await wait(Math.min(500 * attempt, 1500));
      }

      var cart = await fetchCart(root, 2500).catch(function () {
        return null;
      });

      if (cart && cartHasSubmission(cart, submissionId)) {
        return cart;
      }
    }

    return null;
  }

  function loadState(section, cards) {
    var raw;
    var storageKey = getStorageKey(section);

    try {
      raw = window.sessionStorage.getItem(storageKey);
    } catch (error) {
      return {};
    }

    if (!raw) {
      return {};
    }

    try {
      var parsed = JSON.parse(raw);
      var nextState = {};

      Object.keys(parsed).forEach(function (key) {
        var card = cards.get(key);

        if (!card) {
          return;
        }

        var qty = clamp(Number(parsed[key]) || 0, 0, card.maxQuantity);

        if (qty > 0 && card.available) {
          nextState[key] = qty;
        }
      });

      return nextState;
    } catch (error) {
      return {};
    }
  }

  function persistState(section, state) {
    try {
      window.sessionStorage.setItem(getStorageKey(section), JSON.stringify(state.items));
    } catch (error) {
      /* Session storage is optional for preview state. */
    }
  }

  function clearSubmitState(section, state) {
    state.items = {};
    state.isSubmitting = false;
    persistState(section, state);
  }

  function finishSubmit(section, state, cards, message, tone) {
    clearSubmitState(section, state);
    showStatus(section, message || '', tone || 'info');
    render(section, state, cards);
  }

  function updateQuantity(section, state, cards, key, delta, onAfterRender) {
    var card = cards.get(key);

    if (!card || !card.available) {
      return;
    }

    var currentQty = state.items[key] || 0;
    var nextQty = clamp(currentQty + delta, 0, card.maxQuantity);

    if (nextQty <= 0) {
      delete state.items[key];
    } else {
      state.items[key] = nextQty;
    }

    persistState(section, state);
    render(section, state, cards);
    if (typeof onAfterRender === 'function') {
      onAfterRender();
    }
  }

  function render(section, state, cards, onAfterRender) {
    var summary = getSummary(state, cards);
    var minItemsRequired = Number(section.dataset.minItemsRequired || 2);
    var currencyCode = section.dataset.currencyCode || 'GBP';
    var hint = section.querySelector('[data-progress-hint]');
    var footerItems = section.querySelector('[data-footer-items]');
    var footerPrice = section.querySelector('[data-footer-price]');
    var checkoutButton = section.querySelector('[data-bundle-submit]');
    var markers = section.querySelectorAll('[data-progress-marker]');

    cards.forEach(function (card) {
      var qty = state.items[card.key] || 0;
      var isSelected = qty > 0;

      card.element.classList.toggle('is-selected', isSelected);
      card.badge.hidden = !isSelected;
      card.qtyControls.hidden = !isSelected;
      card.addButton.hidden = isSelected || !card.available;
      card.qtyValue.textContent = String(qty);
      card.decrementButton.disabled = qty <= 0;
      card.incrementButton.disabled = qty >= card.maxQuantity;

      if (!card.available) {
        card.addButton.hidden = false;
        card.addButton.disabled = true;
      }
    });

    if (hint) {
      hint.innerHTML = getHintMarkup(summary.totalItems);
    }

    if (footerItems) {
      footerItems.textContent = summary.totalItems === 1 ? '1 item' : summary.totalItems + ' items';
    }

    if (footerPrice) {
      if (summary.discount > 0) {
        footerPrice.innerHTML =
          '<span class="nom-bundle-builder__footer-price-original">' + formatMoney(summary.totalPrice, currencyCode) + '</span>' +
          '<span>' + formatMoney(summary.discountedTotal, currencyCode) + '</span>' +
          '<span class="nom-bundle-builder__footer-price-save">Save ' + summary.discount + '%</span>';
      } else {
        footerPrice.textContent = summary.totalItems > 0 ? formatMoney(summary.totalPrice, currencyCode) : formatMoney(0, currencyCode);
      }
    }

    markers.forEach(function (marker, index) {
      var label = marker.querySelector('[data-progress-marker-label]');
      var achieved = index < getAchievedStepCount(summary.discount);

      marker.classList.remove('is-complete', 'is-active');

      if (achieved) {
        marker.classList.add('is-complete');
      }

      if (label) {
        label.textContent = achieved ? COMPLETE_MARKERS[index] : DEFAULT_MARKERS[index];
      }
    });

    if (checkoutButton) {
      checkoutButton.disabled = state.isSubmitting || summary.totalItems < minItemsRequired;

      if (state.isSubmitting) {
        checkoutButton.textContent = 'Adding...';
      } else if (summary.totalItems >= minItemsRequired) {
        checkoutButton.textContent = shouldUseCartDrawer(section.dataset.postAddDestination || 'cart') ? 'Add bundle' : 'Checkout >';
      } else if (summary.totalItems === 1) {
        checkoutButton.textContent = 'Add 1 more';
      } else {
        checkoutButton.textContent = 'Add items';
      }
    }

    updateProgressFill(section, summary);

    if (typeof onAfterRender === 'function') {
      window.requestAnimationFrame(onAfterRender);
    }
  }

  async function submitBundle(section, state, cards) {
    var root = normalizeRoot(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var destination = section.dataset.postAddDestination || 'cart';
    var summary = getSummary(state, cards);
    var submissionId = createSubmissionId();
    var items = [];

    if (summary.totalItems < Number(section.dataset.minItemsRequired || 2)) {
      return;
    }

    cards.forEach(function (card) {
      var qty = state.items[card.key] || 0;

      if (qty <= 0) {
        return;
      }

      items.push({
        id: Number(card.variantId),
        quantity: qty,
        properties: {
          _nom_bundle_builder: 'true',
          _nom_bundle_page: section.dataset.pageHandle || 'preview',
          _nom_bundle_discount_preview: String(summary.discount),
          _nom_bundle_discount_tier: String(summary.discount || 0),
          _nom_bundle_item_count: String(summary.totalItems),
          _nom_bundle_submission_id: submissionId
        }
      });
    });

    if (!items.length) {
      return;
    }

    state.isSubmitting = true;
    showStatus(section, '', 'info');
    render(section, state, cards);

    try {
      var response;

      try {
        response = await fetchWithTimeout(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        }, 12000, 'The bundle add request took too long.');
      } catch (addError) {
        var submittedCart = await findSubmittedBundle(root, submissionId).catch(function () {
          return null;
        });

        if (submittedCart) {
          if (shouldUseCartDrawer(destination)) {
            var recoveredDrawerDidUpdate = true;

            await withTimeout(refreshNomCartDrawer(), 8000).catch(function (drawerError) {
              recoveredDrawerDidUpdate = false;
              console.error(drawerError);
            });

            if (recoveredDrawerDidUpdate) {
              finishSubmit(section, state, cards);
            } else {
              clearSubmitState(section, state);
              window.location.href = getBundleRedirectPath(root, 'cart');
            }

            return;
          }

          clearSubmitState(section, state);
          window.location.href = getBundleRedirectPath(root, destination);
          return;
        }

        if ((addError && addError.message || '').indexOf('too long') !== -1) {
          finishSubmit(
            section,
            state,
            cards,
            'We could not confirm the cart update. Open your cart to check before adding again.',
            'error'
          );
          return;
        }

        throw addError;
      }

      if (!response.ok) {
        var payload = await response.json().catch(function () {
          return {};
        });
        throw new Error(payload.description || 'Unable to add the bundle to cart.');
      }

      if (shouldUseCartDrawer(destination)) {
        var drawerDidUpdate = true;

        await withTimeout(refreshNomCartDrawer(), 8000).catch(function (drawerError) {
          drawerDidUpdate = false;
          console.error(drawerError);
        });

        if (drawerDidUpdate) {
          finishSubmit(section, state, cards);
        } else {
          clearSubmitState(section, state);
          window.location.href = getBundleRedirectPath(root, 'cart');
        }

        return;
      }

      clearSubmitState(section, state);
      window.location.href = getBundleRedirectPath(root, destination);
    } catch (error) {
      state.isSubmitting = false;
      showStatus(section, error.message || 'Unable to add the bundle to cart.', 'error');
      render(section, state, cards);
    }
  }

  function initSection(section) {
    if (!section || section.dataset.bundleBuilderReady === 'true') {
      return;
    }

    var cards = new Map();
    var footer = section.querySelector('[data-bundle-footer]');
    var state = {
      items: {},
      isSubmitting: false
    };

    function syncFooterState() {
      syncShopifyPreviewBarOffset(section);

      if (!footer) {
        return;
      }

      section.style.setProperty('--nom-bundle-footer-height', footer.offsetHeight + 'px');
      section.classList.toggle('is-footer-docked', section.getBoundingClientRect().bottom <= window.innerHeight);
      updateProgressFill(section, getSummary(state, cards));
    }

    function resetSubmitState() {
      state.isSubmitting = false;
      showStatus(section, '', 'info');
      render(section, state, cards, syncFooterState);
    }

    section.querySelectorAll('[data-bundle-card]').forEach(function (element) {
      var key = element.dataset.key;
      var addButton = element.querySelector('[data-bundle-add]');
      var qtyControls = element.querySelector('[data-bundle-qty-controls]');
      var qtyValue = element.querySelector('[data-bundle-qty]');
      var incrementButton = element.querySelector('[data-bundle-increment]');
      var decrementButton = element.querySelector('[data-bundle-decrement]');
      var badge = element.querySelector('[data-bundle-selected-badge]');

      cards.set(key, {
        key: key,
        element: element,
        addButton: addButton,
        qtyControls: qtyControls,
        qtyValue: qtyValue,
        incrementButton: incrementButton,
        decrementButton: decrementButton,
        badge: badge,
        available: element.dataset.available === 'true',
        variantId: element.dataset.variantId,
        maxQuantity: Number(element.dataset.maxQuantity || section.dataset.maxQuantity || 3),
        price: Number(element.dataset.price || 0)
      });
    });

    state.items = loadState(section, cards);
    section.dataset.bundleBuilderReady = 'true';

    section.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-bundle-add]');
      var incrementButton = event.target.closest('[data-bundle-increment]');
      var decrementButton = event.target.closest('[data-bundle-decrement]');
      var submitButton = event.target.closest('[data-bundle-submit]');
      var card;

      if (addButton) {
        card = addButton.closest('[data-bundle-card]');
        updateQuantity(section, state, cards, card.dataset.key, 1, syncFooterState);
        return;
      }

      if (incrementButton) {
        card = incrementButton.closest('[data-bundle-card]');
        updateQuantity(section, state, cards, card.dataset.key, 1, syncFooterState);
        return;
      }

      if (decrementButton) {
        card = decrementButton.closest('[data-bundle-card]');
        updateQuantity(section, state, cards, card.dataset.key, -1, syncFooterState);
        return;
      }

      if (submitButton && !submitButton.disabled && !state.isSubmitting) {
        submitBundle(section, state, cards);
      }
    });

    window.addEventListener('scroll', syncFooterState, { passive: true });
    window.addEventListener('resize', syncFooterState);
    window.addEventListener('pageshow', resetSubmitState);
    window.addEventListener('pagehide', function () {
      state.isSubmitting = false;
    });

    render(section, state, cards, syncFooterState);
    window.setTimeout(syncFooterState, 500);
    window.setTimeout(syncFooterState, 1500);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector(SECTION_SELECTOR) || event.target);
  });
})();
